import "esbuild-css-modules-plugin-ns-css:src/artifacts/shared/styles/alert/toast.module.css";

export default {
  "alert": "toast-module__alert_i6zhXa__010",
  "toastSlide": "toast-module__toast-slide_i6zhXa__010"
};
      